module.exports = __webpack_public_path__ + "img/lmdc-logo-plain.c33f02b7.png";